// extracted by mini-css-extract-plugin
export default {"applicationWrapper":"Application_applicationWrapper__GSnqC","applicationContainer":"Application_applicationContainer__Qp0WM"};